import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import LogoInteractive from '../logo/LogoInteractive';
//style
import './interactivemap.styl';
//image
import map from '../../media/interactive-map.png';

class InteractiveMap extends React.Component {
  render(){
    return (
      <div className='interactive-map-container-inner col-xs-12 col-md-7 col-lg-6'>
        <LogoInteractive topic='industry' />
        <LogoInteractive topic='office' />
        <LogoInteractive topic='bike' />
        <LogoInteractive topic='person' />
        <LogoInteractive topic='home' />
        <LogoInteractive topic='car' />
        <img src={map} alt='Interactive map' className='interactive-map' />
      </div>
    );
  }
}

export default InteractiveMap;



// WEBPACK FOOTER //
// ./src/components/interactivemap/InteractiveMap.js